/**
 * Default environment configuration with placeholder tokens.
 *
 * Used by dev, staging, and production builds. Placeholders are replaced
 * at container startup by docker-entrypoint.sh using environment variables.
 *
 * For local development, angular.json swaps this file with
 * environment.local.ts which has real values.
 */
export const environment = {
  apiBaseUrl: '%%API_BASE_URL%%',
  firebase: {
    apiKey: '%%FIREBASE_API_KEY%%',
    authDomain: '%%FIREBASE_AUTH_DOMAIN%%',
    projectId: '%%FIREBASE_PROJECT_ID%%',
    storageBucket: '%%FIREBASE_STORAGE_BUCKET%%',
    messagingSenderId: '%%FIREBASE_MESSAGING_SENDER_ID%%',
    appId: '%%FIREBASE_APP_ID%%',
  },
};
